import { createFileRoute } from '@tanstack/react-router';
import UserView from '../../../features/management/users/user/view';
import {
  createPermissionGuard,
  getPermissionSet,
  USER_MANAGEMENT_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute('/verwaltung/benutzer/$userId')({
  component: UserView,
  beforeLoad: createPermissionGuard(
    getPermissionSet(USER_MANAGEMENT_PERMISSIONS, 'READ'),
  ),
});

export const ViewUserRoute = Route;
